import { IStackProps } from "@fluentui/react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { logEvent } from "../../../helper/AppInsightsHelper";
import { Loader } from "../../../SharedComponents/Loader";
import FeatureDataView from "./FeatureDataView";
import FeatureDataViewForSecurityCopilot from "./FeatureDataViewForSecurityCopilot";
import FeaturePivot from "./FeaturePivot";

export default function CustomerFeatureView(props: any) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tenantId = searchParams.get("id") ?? undefined;

  // Initialize selectedFamily from URL parameter or default
  const defaultFamily = "Microsoft Purview";
  const [selectedFamily, setSelectedFamily] = useState(() => {
    const section = searchParams.get("section");
    return section ? section : (sessionStorage.getItem("featureTelemetry_lastViewedFamily") ?? defaultFamily);
  });

  const rowProps: IStackProps = { horizontal: true, verticalAlign: "center" };
  const tokens = { spinnerStack: { childrenGap: 20 } };

  // Enhanced setSelectedFamily that also updates URL
  const handleFamilyChange = (family: string) => {
    setSelectedFamily(family);
    sessionStorage.setItem("featureTelemetry_lastViewedFamily", family);

    // Get current URL parameters and update the section parameter
    const currentParams = Object.fromEntries(searchParams.entries());
    setSearchParams({
      ...currentParams,
      section: family
    });
  };

  // Update selectedFamily when URL changes
  useEffect(() => {
    const sectionFromUrl = searchParams.get("section");
    if (sectionFromUrl && sectionFromUrl !== selectedFamily) {
      setSelectedFamily(sectionFromUrl);
    }
  }, [searchParams]);

  useEffect(() => {
    const customProps = {
      productFamily: selectedFamily,
      tenantId: tenantId,
      tenantName: props.tenantName
    };
    logEvent("Features Telemetry", "Customer Page", "CustomerFeatureView", customProps);
  }, [selectedFamily]);

  return (
    <div className="p-4">
      {/* Pivot Component */}
      <FeaturePivot selectedFamily={selectedFamily} setSelectedFamily={handleFamilyChange} />

      {/* Data Loader */}
      {tenantId ? (
        selectedFamily === "Security Copilot" ? (
          <FeatureDataViewForSecurityCopilot tenantId={tenantId} selectedFamily={selectedFamily} />
        ) : (
          <FeatureDataView selectedFamily={selectedFamily} tenantId={tenantId} />
        )
      ) : (
        <div>No tenant ID provided. Please check the URL.</div>
      )}

      {/* Loader (Optional Global State) */}
      <Loader rowProps={rowProps} spinnerStack={tokens.spinnerStack} loading={false} />
    </div>
  );
}
